module.exports = __webpack_public_path__ + "static/media/truck.56be9a13.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/truck.svg
// module id = 1717
// module chunks = 0